<template>
  <figure v-imagelazy class="bottom-image-wrapper">
    <svg viewBox="25 25 50 50">
      <circle cx="50" cy="50" r="20"></circle>
    </svg>
    <img
      class="bottom-image-image"
      :id="url"
      :data-url="url"
      alt="product-image"
    >
  </figure>
</template>
<script>
import imageLazyLoad from '@/directives/imageLazyLoad'
export default {
  name: 'LazyImage',
  directives: {
    imagelazy: imageLazyLoad
  },
  props: {
    url: {
      type: String,
      required: true,
    }
  },
}
</script>
<style scoped>
figure {
  margin: 0;
}
.bottom-image-wrapper {
  overflow: hidden;
  width: 100%;
  overflow: hidden;
  min-height: 100px;
}
.bottom-image-image {
  width: inherit;
  transition: 0.2s;
}
.bottom-image-image:hover {
  transform: scale(1.2); 
}
.loaded svg {
  display: none;
}
svg {
  width: 3.75em;
  transform-origin: center;
  animation: rotate 2s linear infinite;
}

circle {
  fill: none;
  stroke: #fc2f70;
  stroke-width: 2;
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dashoffset: -125px;
  }
}
</style>
